import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';

export const canUploadCurrentCart = () => {
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return true;
};
